(function () {
  var CARD_QUICK_ADD_BOUND = "data-sw-card-quick-add-bound";
  var CARD_QUICK_ADD_LOADING = "data-sw-card-quick-add-loading";
  var CARD_QUICK_ADD_SELECTOR = ".sw-card__form";
  var SOURCE = "seaweed-product-cart-drawer";

  function cloneChildren(node) {
    return Array.prototype.map.call(node.childNodes, function (child) {
      return document.importNode(child, true);
    });
  }

  function sectionNode(html, selector) {
    if (!html) return null;

    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.querySelector(selector);
  }

  function replaceFromSection(targetSelector, html, sourceSelector) {
    var target = document.querySelector(targetSelector);
    var source = sectionNode(html, sourceSelector);

    if (!target || !source) return false;

    target.replaceChildren.apply(target, cloneChildren(source));
    return true;
  }

  function mergeSections(cartData, sections) {
    var safeCartData = cartData || {};

    return Object.assign({}, safeCartData, {
      sections: Object.assign({}, safeCartData.sections || {}, sections || {})
    });
  }

  async function ensureCartSections(cartData) {
    if (
      cartData &&
      cartData.sections &&
      cartData.sections["cart-drawer"] &&
      cartData.sections["header-cart-status"]
    ) {
      return cartData;
    }

    var rootUrl = window.routes && window.routes.root_url ? window.routes.root_url : "/";
    var url = new URL(rootUrl, window.location.origin);
    url.searchParams.set("sections", "cart-drawer,header-cart-status");

    var response = await fetch(url.toString(), {
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) throw new Error("Unable to fetch cart drawer sections");

    return mergeSections(cartData, await response.json());
  }

  function cartAddFetchConfig(body) {
    var helper = window.ECXHelper || {};
    var baseConfig = helper.fetchConfigHTTP || {};
    var headers = Object.assign({}, baseConfig.headers || {}, {
      Accept: "application/json"
    });

    return Object.assign({}, baseConfig, {
      body: body,
      headers: headers,
      method: baseConfig.method || "POST"
    });
  }

  function cartAddUrl() {
    return window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add.js";
  }

  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
  }

  function goToCart() {
    window.location.assign(cartUrl());
  }

  function isDrawerCart() {
    return document.body && document.body.getAttribute("data-cart-type") === "drawer";
  }

  function renderHeaderCartStatus(sectionHtml) {
    return (
      replaceFromSection("#headerCartStatus", sectionHtml, ".shopify-section") ||
      replaceFromSection("#headerCartStatus", sectionHtml, "body")
    );
  }

  function renderCartDrawer(cartData, cartDrawerForm) {
    var rendered = false;

    if (!cartData || !cartData.sections || !cartData.sections["cart-drawer"]) return false;

    rendered =
      replaceFromSection(
        "#cartDrawer .js-cart-drawer-wrapper",
        cartData.sections["cart-drawer"],
        "#cartDrawer .js-cart-drawer-wrapper"
      ) ||
      replaceFromSection(
        "#cartDrawer .js-cart-drawer-wrapper",
        cartData.sections["cart-drawer"],
        ".js-cart-drawer-wrapper"
      );

    if (rendered) return rendered;

    if (cartDrawerForm && typeof cartDrawerForm.renderContents === "function") {
      try {
        cartDrawerForm.renderContents(cartData);
        rendered = true;
      } catch (error) {
        console.warn("Seaweed cart drawer render fallback active", error);
      }
    }

    return rendered;
  }

  async function openCartDrawer(cartData, opener, cartDrawerOverride, cartDrawerFormOverride) {
    if (!isDrawerCart()) {
      goToCart();
      return;
    }

    var cartDrawer = cartDrawerOverride || document.querySelector("ecx-cart-drwr");
    var cartDrawerForm = cartDrawerFormOverride || document.querySelector("ecx-cart-drwr-frm");
    var hydratedCartData = await ensureCartSections(cartData);

    if (hydratedCartData.sections && hydratedCartData.sections["header-cart-status"]) {
      renderHeaderCartStatus(hydratedCartData.sections["header-cart-status"]);
    }

    renderCartDrawer(hydratedCartData, cartDrawerForm);

    if (cartDrawer && typeof cartDrawer.openDrawer === "function") {
      cartDrawer.openDrawer(opener || document.querySelector(".js-header-cart-status-btn"));
      document.dispatchEvent(new CustomEvent("seaweed:cart-drawer:update", { detail: { source: SOURCE } }));
      return;
    }

    goToCart();
  }

  function cardQuickAddFormData(form) {
    var formData = new FormData(form);
    formData.append("sections", "cart-drawer,header-cart-status");
    formData.append("sections_url", window.location.pathname);
    return formData;
  }

  function setCardQuickAddLoading(form, isLoading) {
    var submitButton = form.querySelector('[type="submit"]');

    if (isLoading) {
      form.setAttribute(CARD_QUICK_ADD_LOADING, "true");
    } else {
      form.removeAttribute(CARD_QUICK_ADD_LOADING);
    }

    if (!submitButton) return;

    if (isLoading) {
      submitButton.setAttribute("aria-disabled", "true");
      submitButton.setAttribute("disabled", "disabled");
    } else {
      submitButton.removeAttribute("aria-disabled");
      submitButton.removeAttribute("disabled");
    }
  }

  async function parseCartAddResponse(response) {
    var cartData = await response.json().catch(function () {
      return {};
    });
    var message = cartData.description || cartData.message || "Unable to add item to cart";

    if (!response.ok || cartData.status) {
      throw new Error(message);
    }

    return cartData;
  }

  async function handleCardQuickAddSubmit(event) {
    var target = event.target;
    var form = target && target.closest ? target.closest(CARD_QUICK_ADD_SELECTOR) : null;
    var submitter = event.submitter || (form && form.querySelector('[type="submit"]'));
    var response;
    var cartData;

    if (!form) return;

    event.preventDefault();

    if (form.hasAttribute(CARD_QUICK_ADD_LOADING)) return;

    setCardQuickAddLoading(form, true);

    try {
      response = await fetch(cartAddUrl(), cartAddFetchConfig(cardQuickAddFormData(form)));
      cartData = await parseCartAddResponse(response);
    } catch (error) {
      console.error("Seaweed card quick add failed", error);
      setCardQuickAddLoading(form, false);
      return;
    }

    try {
      await openCartDrawer(cartData, submitter);
    } catch (error) {
      console.error("Seaweed card cart drawer failed", error);
      goToCart();
    } finally {
      setCardQuickAddLoading(form, false);
    }
  }

  function bindCardQuickAdd() {
    if (document.documentElement.hasAttribute(CARD_QUICK_ADD_BOUND)) return;

    document.documentElement.setAttribute(CARD_QUICK_ADD_BOUND, "true");
    document.addEventListener("submit", handleCardQuickAddSubmit);
  }

  // Base Blum already opens the cart drawer after a product-form add-to-cart
  // (theme setting add_to_cart_confirmation = "show_drawer"), so no patch of the
  // base product-form element is needed. This script only adds the card-level
  // quick-add that base Blum doesn't provide.
  function start() {
    bindCardQuickAdd();
  }

  window.SeaweedCartDrawer = Object.assign({}, window.SeaweedCartDrawer || {}, {
    ensureCartSections: ensureCartSections,
    open: openCartDrawer
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
